import React from 'react';
import { Mail, Facebook, Instagram, Twitter } from 'lucide-react';

export const Footer = () => {
  const currentYear = new Date().getFullYear();

  const footerLinks = {
    product: [
      { label: 'Cómo funciona', href: '#como-funciona' },
      { label: 'Características', href: '#caracteristicas' },
      { label: 'Planes', href: '#planes' },
      { label: 'FAQ', href: '#faq' }
    ],
    legal: [
      { label: 'Términos de servicio', href: '#' },
      { label: 'Política de privacidad', href: '#' },
      { label: 'Seguridad', href: '#' }
    ],
    social: [
      { icon: Facebook, label: 'Facebook', href: '#' },
      { icon: Instagram, label: 'Instagram', href: '#' },
      { icon: Twitter, label: 'Twitter', href: '#' }
    ]
  };

  const scrollToSection = (href) => {
    if (href.startsWith('#')) {
      const id = href.substring(1);
      const element = document.getElementById(id);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }
  };

  return (
    <footer className="bg-gray-900 text-gray-300 pt-16 pb-8">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12">
          {/* Brand Column */}
          <div className="lg:col-span-1">
            <img
              src={`${process.env.PUBLIC_URL}/tuasistencia-white.png`}
              alt="Logo de TuAsistencia"
              className="h-10 w-auto mb-4"
              loading="lazy"
              decoding="async"
            />
            <p className="text-sm text-gray-400 leading-relaxed mb-4">
              Control de asistencia escolar simple, rápido y efectivo para instituciones educativas.
            </p>
            <div className="flex items-center gap-2 text-sm">
              <Mail size={16} className="text-blue-400" />
              <a
                href="mailto:contacto@bitakora.com.co"
                className="hover:text-white transition-colors"
              >
                contacto@bitakora.com.co
              </a>
            </div>
          </div>

          {/* Product Links */}
          <div>
            <h3 className="text-white font-semibold mb-4">Producto</h3>
            <ul className="space-y-3">
              {footerLinks.product.map((link, index) => (
                <li key={index}>
                  <button
                    onClick={() => scrollToSection(link.href)}
                    className="text-sm hover:text-white transition-colors text-left"
                  >
                    {link.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          {/* Legal Links */}
          <div>
            <h3 className="text-white font-semibold mb-4">Legal</h3>
            <ul className="space-y-3">
              {footerLinks.legal.map((link, index) => (
                <li key={index}>
                  <a
                    href={link.href}
                    className="text-sm hover:text-white transition-colors"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Social & Contact */}
          <div>
            <h3 className="text-white font-semibold mb-4">Síguenos</h3>
            <div className="flex gap-4">
              {footerLinks.social.map((social, index) => {
                const Icon = social.icon;
                return (
                  <a
                    key={index}
                    href={social.href}
                    className="w-10 h-10 bg-gray-800 rounded-lg flex items-center justify-center hover:bg-blue-600 transition-colors"
                    aria-label={social.label}
                  >
                    <Icon size={18} />
                  </a>
                );
              })}
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="pt-8 border-t border-gray-800">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4 text-sm text-gray-500">
            <p>
              © {currentYear} TuAsistencia by Bitakora. Todos los derechos reservados.
            </p>
            <p>
              Hecho con dedicación para instituciones educativas colombianas.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};
